import { render, staticRenderFns } from "./WorkflowVisualisation.vue?vue&type=template&id=54c956b6&"
import script from "./WorkflowVisualisation.vue?vue&type=script&lang=ts&"
export * from "./WorkflowVisualisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports